const config = {
    baseUrl: window.location.href.indexOf("localhost") !== -1 ? "http://127.0.0.1:5000" : ''
}
export default config